import { useDispatch } from "noval";

const { useEffect } = require("react");

export const useResizeStorageListener = (
  setCookiesApproval,
  getCookiesApproval
) => {
  const { dispatch } = useDispatch();
  useEffect(() => {
    const observerResize = () => {
      switch (true) {
        case window.innerWidth > 1279:
          dispatch({ screen: "desktop" });
          break;
        case window.innerWidth <= 1279 && window.innerWidth > 1024:
          dispatch({ screen: "laptop" });
          break;
        case window.innerWidth <= 1024 && window.innerWidth >= 768:
          dispatch({ screen: "tablet" });
          break;
        case window.innerWidth < 768 && window.innerWidth > 639:
          dispatch({ screen: "phone" });
          break;
        default:
          dispatch({ screen: "sm-phone" });
          break;
      }
    };

    const handleStorageChange = () => {
      setCookiesApproval(getCookiesApproval());
    };

    observerResize();
    window.addEventListener("resize", observerResize);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("resize", observerResize);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
};
